// ModalContext.js
import React, { createContext, useContext, useState } from "react";

const ModalRsuiteContext = createContext();

export const ModalProviderRsuite = ({ children }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [fullscreen, setFullscreen] = useState(false);
  const [title, setTitle] = useState("");
  const [size, setSize] = useState("lg");
  const openModal = (content) => {
    setModalContent(content);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalContent(null);
  };

  return (
    <ModalRsuiteContext.Provider
      value={{
        isModalOpen,
        openModal,
        closeModal,
        modalContent,
        fullscreen,
        setFullscreen,
        size,
        title,
        setTitle,
        setSize,
      }}
    >
      {children}
    </ModalRsuiteContext.Provider>
  );
};

export const useModal = () => {
  return useContext(ModalRsuiteContext);
};
